import isServerSideRendering from './isServerSideRendering';

export default function encodeBase64(str: string) {
  return isServerSideRendering
    ? Buffer.from(str, 'utf8').toString('base64')
    : window.btoa(str);
}
